import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'Index',
            component: resolve => require(['@/views/index/Index.vue'], resolve)
        },
        {
            path: '/corelDrawLogin',
            name: 'corelDrawLogin',
            component: resolve => require(['@/views/index/corelDrawLogin'], resolve)
        },
        {
            path: '/ForgetPass',
            name: 'ForgetPass',
            component: resolve => require(['@/views/index/ForgetPass.vue'], resolve)
        },
        {
            path: '/Register',
            name: 'Register',
            component: resolve => require(['@/views/index/Register.vue'], resolve)
        },
        {
            path: '/RegisterInformation',
            name: 'RegisterInformation',
            component: resolve => require(['@/views/index/RegisterInformation.vue'], resolve)
        },
        {
            path: '/UpdatePass',
            name: 'UpdatePass',
            component: resolve => require(['@/views/index/UpdatePass.vue'], resolve)
        },
        {
            path: '/EnterpriseInfo',
            name: 'EnterpriseInfo',
            component: resolve => require(['@/views/index/EnterpriseInfo.vue'], resolve)
        },
        {
            path: '/myCoupon',
            name: 'myCoupon',
            component: resolve => require(['@/views/index/myCoupon.vue'], resolve)
        },
        {
            path: '/Address',
            name: 'Address',
            component: resolve => require(['@/views/index/Address.vue'], resolve)
        },
        {
            path: '/questionList',
            name: 'questionList',
            component: resolve => require(['@/views/index/questionList.vue'], resolve)
        },
        {
            path: '/Distribution',
            name: 'Distribution',
            component: resolve => require(['@/views/index/distribution.vue'], resolve),
            children: [{
                    path: '/',
                    name: 'DistributionCommission',
                    component: resolve => require(['@/views/index/distribution_commission.vue'], resolve)
                },
                {
                    path: '/DistributionCash',
                    name: 'DistributionCash',
                    component: resolve => require(['@/views/index/distribution_cash.vue'], resolve)
                },
                {
                    path: '/DistributionCoupon',
                    name: 'DistributionCoupon',
                    component: resolve => require(['@/views/index/distribution_coupon.vue'], resolve)
                },
                {
                    path: '/DistributionOrders',
                    name: 'DistributionOrders',
                    component: resolve => require(['@/views/index/distribution_orders.vue'], resolve),
                    children: [{
                            path: '/',
                            name: 'DistributionOrdersAll',
                            component: resolve => require(['@/views/index/distribution_ordersAll.vue'], resolve)
                        },
                        {
                            path: '/DistributionOrdersDraft',
                            name: 'DistributionOrdersDraft',
                            component: resolve => require(['@/views/index/distribution_ordersDraft.vue'], resolve)
                        },
                        {
                            path: '/DistributionOrdersCheckIn',
                            name: 'DistributionOrdersCheckIn',
                            component: resolve => require(['@/views/index/distribution_ordersCheckIn.vue'], resolve)
                        },
                        {
                            path: '/DistributionOrdersNonPayment',
                            name: 'DistributionOrdersNonPayment',
                            component: resolve => require(['@/views/index/distribution_ordersNonPayment.vue'], resolve)
                        },
                        {
                            path: '/DistributionOrdersInProduction',
                            name: 'DistributionOrdersInProduction',
                            component: resolve => require(['@/views/index/distribution_ordersInProduction.vue'], resolve)
                        },
                        {
                            path: '/DistributionOrdersAccomplish',
                            name: 'DistributionOrdersAccomplish',
                            component: resolve => require(['@/views/index/distribution_ordersAccomplish.vue'], resolve)
                        }
                    ]
                }
            ]
        },
        {
            path: '/customerInfo',
            name: 'customerInfo',
            component: resolve => require(['@/views/index/customerInfo.vue'], resolve)
        },
        {
            path: '/AddressAdd',
            name: 'AddressAdd',
            component: resolve => require(['@/views/index/AddressAdd.vue'], resolve)
        },
        {
            path: '/AddressUpdate',
            name: 'AddressUpdate',
            component: resolve => require(['@/views/index/AddressUpdate.vue'], resolve)
        },
        {
            path: '/UpdateEnterpriseInfo',
            name: 'UpdateEnterpriseInfo',
            component: resolve => require(['@/views/index/UpdateEnterpriseInfo.vue'], resolve)
        },
        {
            path: '/Product',
            name: 'Product',
            component: resolve => require(['@/views/index/Product.vue'], resolve)
        },
        {
            path: '/ApplyForJoining',
            name: 'ApplyForJoining',
            component: resolve => require(['@/views/index/ApplyForJoining.vue'], resolve)
        },
        {
            path: '/helpVideo',
            name: 'helpVideo',
            component: resolve => require(['@/views/index/helpVideo.vue'], resolve)
        },
        {
            path: '/ProductDetail',
            name: 'ProductDetail',
            component: resolve => require(['@/views/index/ProductDetail.vue'], resolve)
        },
        {
            path: '/Order',
            name: 'Order',
            component: resolve => require(['@/views/index/Order.vue'], resolve)
        }, {
            path: '/OrderEdit',
            name: 'OrderEdit',
            component: resolve => require(['@/views/index/OrderEdit.vue'], resolve)
        },
        {
            path: '/Examine',
            name: 'Examine',
            component: resolve => require(['@/views/index/Examine.vue'], resolve)
        },
        {
            path: '/Payment',
            name: 'Payment',
            component: resolve => require(['@/views/index/Payment.vue'], resolve)
        },
        {
            path: '/Unpaid',
            name: 'Unpaid',
            component: resolve => require(['@/views/index/Unpaid.vue'], resolve)
        },
        {
            path: '/orderProduction',
            name: 'orderProduction',
            component: resolve => require(['@/views/index/orderProduction.vue'], resolve)
        },
        {
            path: '/OrderDetail',
            name: 'OrderDetail',
            component: resolve => require(['@/views/index/OrderDetail.vue'], resolve)
        },
        {
            path: '/SendOrder',
            name: 'SendOrder',
            component: resolve => require(['@/views/index/SendOrder.vue'], resolve)
        },
        {
            path: '/OrderPayment',
            name: 'OrderPayment',
            component: resolve => require(['@/views/index/OrderPayment.vue'], resolve)
        },
        {
            path: '/ProductionSchedule',
            name: 'ProductionSchedule',
            component: resolve => require(['@/views/index/ProductionSchedule.vue'], resolve)
        },
        {
            path: '/Evaluate',
            name: 'Evaluate',
            component: resolve => require(['@/views/index/Evaluate.vue'], resolve)
        },
        {
            path: '/SendSuccess',
            name: 'SendSuccess',
            component: resolve => require(['@/views/index/SendSuccess.vue'], resolve)
        },
        {
            path: '/RegisterSuccess',
            name: 'RegisterSuccess',
            component: resolve => require(['@/views/index/RegisterSuccess.vue'], resolve)
        },
        {
            path: '/UpdateSuccess',
            name: 'UpdateSuccess',
            component: resolve => require(['@/views/index/UpdateSuccess.vue'], resolve)
        },
        {
            path: '/OrderList',
            name: 'OrderList',
            component: resolve => require(['@/views/index/OrderList.vue'], resolve),
            redirect: { name: 'OrderListALl' },
            children: [{
                    path: 'OrderList1',
                    name: 'OrderList1',
                    component: resolve => require(['@/views/index/OrderList1.vue'], resolve),
                },
                {
                    path: 'OrderList1Detail',
                    name: 'OrderList1Detail',
                    component: resolve => require(['@/views/index/OrderList1Detail.vue'], resolve)
                },
                {
                    path: 'orderList2Detail',
                    name: 'orderList2Detail',
                    component: resolve => require(['@/views/index/orderList2Detail.vue'], resolve)
                },
                {
                    path: 'OrderList3Detail',
                    name: 'OrderList3Detail',
                    component: resolve => require(['@/views/index/OrderList3Detail.vue'], resolve)
                },
                {
                    path: 'OrderList4Detail',
                    name: 'OrderList4Detail',
                    component: resolve => require(['@/views/index/OrderList4Detail.vue'], resolve)
                },
                {
                    path: 'OrderList5Detail',
                    name: 'OrderList5Detail',
                    component: resolve => require(['@/views/index/OrderList5Detail.vue'], resolve)
                },
                {
                    path: 'OrderList2',
                    name: 'OrderList2',
                    component: resolve => require(['@/views/index/OrderList2.vue'], resolve)
                },
                {
                    path: 'OrderList3',
                    name: 'OrderList3',
                    component: resolve => require(['@/views/index/OrderList3.vue'], resolve)
                },
                {
                    path: 'OrderList4',
                    name: 'OrderList4',
                    component: resolve => require(['@/views/index/OrderList4.vue'], resolve)
                },
                {
                    path: 'OrderList5',
                    name: 'OrderList5',
                    component: resolve => require(['@/views/index/OrderList5.vue'], resolve)
                },
                {
                    path: 'OrderList6',
                    name: 'OrderList6',
                    component: resolve => require(['@/views/index/OrderList6.vue'], resolve)
                }, ,
                {
                    path: 'OrderList7',
                    name: 'OrderList7',
                    component: resolve => require(['@/views/index/OrderList7.vue'], resolve)
                },
                {
                    path: 'OrderListALl',
                    name: 'OrderListALl',
                    component: resolve => require(['@/views/index/OrderListAll.vue'], resolve)
                }
            ]
        },
        {
            path: '/Message',
            name: 'Message',
            component: resolve => require(['@/views/index/Message.vue'], resolve)
        },
        {
            path: '/Sq',
            name: 'Sq',
            component: resolve => require(['@/views/index/Sq.vue'], resolve)
        },
        {
            path: '/OrderBrief',
            name: 'OrderBrief',
            component: resolve => require(['@/views/index/OrderBrief.vue'], resolve)
        },
        {
            path: '/setting',
            name: 'setting',
            // meta: { keepAlive: true, footBool: true, isBack: false, }, // keepAlive 需要缓存// footBool 是否显示页脚true 不显示  // isBack用于判断上一个页面是哪个
            component: resolve => require(['@/views/home/fastQuotation/setting_new.vue'], resolve) //canvas操作页面

        }, {
            path: '/quotationDetail',
            name: 'quotationDetail',
            meta: { footBool: true, }, // footBool 是否显示页脚true 不显示
            component: () =>
                import ('@/views/home/quotation/quotationDetail.vue'), //报价单详情
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (!sessionStorage.getItem('loginInfo')) {
            Router.push('/');
        }
        return { x: 0, y: 0 }
    },

})


// WEBPACK FOOTER //
// ./src/router/index.js